'use strict';
(() => {
  const dialog = document.querySelector('[data-jmo-newsletter]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const params = new URLSearchParams(location.search);
  if (!document.body.classList.contains('template-index') || params.has('view') || /\/(products|cart|checkouts?|account)(\/|$)/.test(location.pathname)) return;

  const form = dialog.querySelector('form');
  const response = dialog.querySelector('[data-newsletter-response]');
  const closeButton = dialog.querySelector('.jmo-newsletter-close');
  let opener = null;
  let leavingPage = false;

  function blocked() {
    const editing = document.activeElement?.closest('input,textarea,select,[contenteditable]:not([contenteditable="false"])');
    return document.hidden || editing || document.body.classList.contains('jmo-panel-open') || document.querySelector('dialog[open], [role="dialog"][aria-modal="true"]') || document.querySelector('[data-header-details][open]');
  }

  function openDialog(trigger = null) {
    if (dialog.open || blocked()) return false;
    opener = trigger || document.activeElement;
    try { dialog.showModal(); } catch { return false; }
    document.documentElement.classList.add('jmo-newsletter-is-open');
    closeButton.focus({ preventScroll: true });
    if (response) response.focus({ preventScroll: true });
    return true;
  }

  function closeDialog() {
    if (!dialog.open) return;
    dialog.close();
  }

  function installTrigger() {
    const footer = document.querySelector('.jmo-footer-brand');
    if (!footer || document.querySelector('#JmoFooterNewsletter') || footer.querySelector('[data-newsletter-open], [data-jmo-footer-newsletter]')) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'jmo-newsletter-trigger';
    button.setAttribute('data-newsletter-open', '');
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute('aria-controls', dialog.id);
    button.textContent = dialog.dataset.newsletterTrigger;
    button.addEventListener('click', () => openDialog(button));
    footer.append(button);
  }

  dialog.querySelectorAll('[data-newsletter-close]').forEach(button => button.addEventListener('click', closeDialog));
  dialog.addEventListener('cancel', event => { event.preventDefault(); closeDialog(); });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('jmo-newsletter-is-open');
    const target = opener?.isConnected && opener !== document.body && opener !== document.documentElement && typeof opener.focus === 'function' ? opener : document.querySelector('#MainContent');
    if (!leavingPage) target?.focus({ preventScroll: true });
    opener = null;
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeDialog();
  });
  dialog.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const controls = [...dialog.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')]
      .filter(control => !control.disabled && control.tabIndex >= 0 && !control.closest('[hidden],[inert]') && control.getClientRects().length);
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (!first) { event.preventDefault(); return; }
    if (event.shiftKey && (document.activeElement === first || !controls.includes(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !controls.includes(document.activeElement))) { event.preventDefault(); first.focus(); }
  });
  form.addEventListener('submit', event => {
    if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
  });
  document.addEventListener('shopify:section:load', installTrigger);
  window.addEventListener('popstate', closeDialog);
  window.addEventListener('pagehide', () => {
    leavingPage = true;
    closeDialog();
    document.documentElement.classList.remove('jmo-newsletter-is-open');
  });
  window.addEventListener('pageshow', () => { leavingPage = false; });
  installTrigger();
  // Open only for an explicit trigger or Shopify's native form response.
  if (response) openDialog();
})();
